import { render } from "./create_propriete.vue?vue&type=template&id=2002bc5e&scoped=true"
import script from "./create_propriete.vue?vue&type=script&lang=js"
export * from "./create_propriete.vue?vue&type=script&lang=js"

import "./create_propriete.vue?vue&type=style&index=0&id=2002bc5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2002bc5e"]])

export default __exports__